export default __webpack_public_path__ + "static/media/13.8d3b224e.jpg";